import  './popularcat.scss';
import {images} from '../../constants'

const PopularCategories = () => {
  return (
    <section className="app_popular-cat">
      <h3>POPULAR CATEGORIES</h3>
      <div className="content-div">
        <div className="gif-div">
          <img src={images.PopularCatGif} alt="popular-gif"/>
        </div>
        <div className='icon-cont'>
          <div className="icon-item">
            <img src={images.PopularCat1} alt='popular-cat-1'/>
            <p>Consult in 30 Mins</p>
          </div>
          <div className="icon-item">
            <img src={images.PopularCat2} alt='popular-cat-2'/>
            <p>Photoshoot</p>
          </div>
          <div className="icon-item">
            <img src={images.PopularCat3} alt='popular-cat-3'/>
            <p>Intimate Hygiene</p>
          </div>
          <div className="icon-item">
            <img src={images.PopularCat4} alt='popular-cat-4'/>
            <p>Yoga/Fitness</p>
          </div>
          <div className="icon-item">
            <img src={images.PopularCat5} alt='popular-cat-5'/>
            <p>Stem Cell Package</p>
          </div>
          <div className="icon-item">
            <img src={images.PopularCat6} alt='popular-cat-6'/>
            <p>Maternity Loans</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PopularCategories